import React from "react";
import Input from "../Ui/input";

import { makeStyles } from "@material-ui/core/";

const useStyle = makeStyles((theme) => ({
  select: {
    "&.MuiInputLabel-shrink": {
      transform: "translate(0, 1.5px) scale(0.97)",
      transformOrigin: "top left",
      color: "red",
    },
  },
  root: {
    "& .MuiFormLabel-root .Mui-disabled": {
      color: "red",
    },
  },
}));

const Forms = (props) => {
  const classes = useStyle(props);
  let formDataElementArray = [];
  for (let key in props.formDetails) {
    formDataElementArray.push({
      id: key,
      config: props.formDetails[key],
    });
  }
  let form = (
    <form>
      {formDataElementArray.map((data, index) => {
        return (
          <Input
            key={index}
            inputType={data.config.elementType}
            elementConfig={data.config.elementConfig}
            value={
              props?.value[data.config.elementConfig.name] !== undefined
                ? props?.value[data.config.elementConfig.name]
                : ""
            }
            display={data.config.display}
            allowFutureDates={data.config.allowFutureDates}
            changed={props.changed}
            handleCheck={props.handleCheck}
            handleMultipleCheck={props.handleMultipleCheck}
            handleRadioChange={props.handleRadioChange}
            icon={data.config.icon}
            maxLength={data.config.maxLength}
            handleChange={props.handleChange}
            isValid={data.config.isValid}
            errorMessage={data.config.errorMessage}
            handelDateChange={props.handelDateChange}
            handelDateChangeEditable={props.handelDateChangeEditable}
            selectFiledName={data.config.selectFiledName}
            selectFiledValue={data.config.selectFiledValue}
            checked={props.value}
          />
        );
      })}
    </form>
  );
  return <div>{form}</div>;
};

export default Forms;
